export enum RECORD_STATUS {
  IDLE = "idle",
  RECORDING = "recording",
  PAUSED = "paused",
}
